document.addEventListener('DOMContentLoaded', () => {
  const signupPopup = document.getElementById('signupPopup');
  const signupPopupClose = document.getElementById('signupPopupClose');
  const signupPopupForm = document.getElementById('signupPopupForm');
  const signupPopupPrompt = document.getElementById('signupPopupPrompt');
  const signupPopupExpanded = document.getElementById('signupPopupExpanded');

  if (signupPopupPrompt) {
    signupPopupPrompt.addEventListener('click', () => {
      signupPopupPrompt.hidden = true;
      signupPopupExpanded.hidden = false;
    });
  }

  if (signupPopup && !sessionStorage.getItem('signupPopupDismissed')) {
    setTimeout(() => {
      signupPopup.classList.add('show');
    }, 3000);
  }

  if (signupPopupClose) {
    signupPopupClose.addEventListener('click', () => {
      signupPopupExpanded.hidden = true;
      signupPopupPrompt.hidden = false;
    });
  }

  if (signupPopupForm) {
    signupPopupForm.addEventListener('submit', (e) => {
      e.preventDefault();
      signupPopupForm.querySelector('button').textContent = 'Subscribed ✓';
      sessionStorage.setItem('signupPopupDismissed', 'true');
      setTimeout(() => signupPopup.classList.remove('show'), 1200);
    });
  }

  const pbMainImg = document.getElementById('pbGalleryMainImg');
  const pbGalleryThumbs = document.querySelectorAll('#pbGalleryThumbs .pb-gallery-thumb');
  const pbGalleryPrev = document.getElementById('pbGalleryPrev');
  const pbGalleryNext = document.getElementById('pbGalleryNext');
  const pbLightbox = document.getElementById('pbLightbox');
  const pbLightboxImg = document.getElementById('pbLightboxImg');
  const pbLightboxClose = document.getElementById('pbLightboxClose');
  const pbLightboxThumbs = document.querySelectorAll('#pbLightboxThumbs .pb-lightbox-thumb');
  const pbLightboxPrev = document.getElementById('pbLightboxPrev');
  const pbLightboxNext = document.getElementById('pbLightboxNext');

  if (pbMainImg && pbGalleryThumbs.length) {
    const pbImages = Array.from(pbGalleryThumbs).map((thumb) => {
      const img = thumb.querySelector('img');
      return { src: img.src, alt: img.alt };
    });

    let pbCurrentIndex = 0;

    const renderPbGallery = () => {
      const current = pbImages[pbCurrentIndex];
      if (!current) return;
      pbMainImg.src = current.src;
      pbMainImg.alt = current.alt;
      pbGalleryThumbs.forEach((t, i) => t.classList.toggle('active', i === pbCurrentIndex));
      if (pbLightbox && pbLightbox.classList.contains('open')) {
        pbLightboxImg.src = current.src;
        pbLightboxImg.alt = current.alt;
        pbLightboxThumbs.forEach((t, i) => t.classList.toggle('active', i === pbCurrentIndex));
      }
    };

    const pbSetIndex = (index) => {
      pbCurrentIndex = index;
      renderPbGallery();
    };

    const pbShowPrev = () => pbSetIndex((pbCurrentIndex - 1 + pbImages.length) % pbImages.length);
    const pbShowNext = () => pbSetIndex((pbCurrentIndex + 1) % pbImages.length);

    const openPbLightbox = () => {
      renderPbGallery();
      if (pbLightbox) pbLightbox.classList.add('open');
    };

    const closePbLightbox = () => {
      if (pbLightbox) pbLightbox.classList.remove('open');
    };

    pbGalleryThumbs.forEach((thumb, i) => {
      thumb.addEventListener('click', () => pbSetIndex(i));
    });

    if (pbGalleryPrev) pbGalleryPrev.addEventListener('click', pbShowPrev);
    if (pbGalleryNext) pbGalleryNext.addEventListener('click', pbShowNext);

    pbMainImg.addEventListener('click', openPbLightbox);

    pbLightboxThumbs.forEach((thumb, i) => {
      thumb.addEventListener('click', () => pbSetIndex(i));
    });

    if (pbLightboxPrev) pbLightboxPrev.addEventListener('click', pbShowPrev);
    if (pbLightboxNext) pbLightboxNext.addEventListener('click', pbShowNext);

    if (pbLightboxClose) {
      pbLightboxClose.addEventListener('click', closePbLightbox);
      pbLightbox.addEventListener('click', (e) => {
        if (e.target === pbLightbox) closePbLightbox();
      });
    }

    document.addEventListener('keydown', (e) => {
      if (pbLightbox && pbLightbox.classList.contains('open') && e.key === 'Escape') closePbLightbox();
      if (e.key === 'ArrowLeft') pbShowPrev();
      if (e.key === 'ArrowRight') pbShowNext();
    });

    renderPbGallery();
  }

  const pbAddToCartForm = document.getElementById('pbAddToCartForm');
  if (pbAddToCartForm) {
    pbAddToCartForm.addEventListener('submit', async (e) => {
      e.preventDefault();
      const button = pbAddToCartForm.querySelector('button[type="submit"]');
      const originalText = button.textContent;
      button.textContent = 'Adding...';
      button.disabled = true;
      try {
        const formData = new FormData(pbAddToCartForm);
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          body: formData,
          headers: { 'Accept': 'application/json' }
        });
        if (!response.ok) throw new Error('Add to cart failed');
        button.textContent = 'Added ✓';
        setTimeout(() => { window.location.href = '/cart'; }, 600);
      } catch (err) {
        button.textContent = originalText;
        button.disabled = false;
        alert('Something went wrong adding this to your cart. Please try again.');
      }
    });
  }

  const pbHighlights = document.querySelectorAll('.pb-review-highlight');
  if (pbHighlights.length) {
    if ('IntersectionObserver' in window) {
      const pbHighlightObserver = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('pb-marker-active');
            pbHighlightObserver.unobserve(entry.target);
          }
        });
      }, { threshold: 0.4 });
      pbHighlights.forEach((el) => pbHighlightObserver.observe(el));
    } else {
      pbHighlights.forEach((el) => el.classList.add('pb-marker-active'));
    }
  }
});
